import { SET_VERSION, SET_BANNER, SET_BANNER_ERRORINFO } from './types';

export default {
    [SET_VERSION](state, { ver }) {
        if (ver !== undefined) state.ver = ver;
    },

    [SET_BANNER](state, data) {
        if (data !== undefined) {
            state.banners = data.banners;
            state.bannersResourceId = data.bannersResourceId;
        }
    },

    [SET_BANNER_ERRORINFO](state, data) {
        if (!data) return;
        state.bannersErrorInfo = data;
    }
};
